export const AUTHOR_AVATARS = {
  MK: 'https://avatars.githubusercontent.com/u/135491799?v=4&size=64',
};

